export var isMono;
export function createPlatFormApi() {
  if (isMono !== undefined) {
    throw new Error('Platform API has already been intialized');
  }
  isMono = true;
}